import * as forms from './forms.js';

jQuery(() => {
  forms.processFormCookies();
  forms.applyDateTypeToDatepickers();
  forms.applyInputMaskingToTelephoneFields();
  forms.applyChangeEventToAutoSubmitSelectFields();
  forms.applyMultiUploadMarkup();
  forms.applyInlineHeroTextPlaceholders();
  forms.relocateConsentBoxesOnInlineHeroForms();
  forms.applyAddressAutocompleteEventListeners();
});
